const DAY = 86400000;

const inboxFindings = (
  stats = {},
  {
    openThread = false,
    activeSequences = [],
    feed = [],
    activeFilter = "",
    now = Date.now(),
    actions = {}
  } = {}
) => {
  const out = [];
  const { allCount = 0, hardBouncedCount = 0, unreadCount = 0 } = stats;
  if (hardBouncedCount > 0 && allCount > 0 && hardBouncedCount / allCount >= 0.05) {
    out.push({
      tone: "bad",
      key: "deliverability",
      label: "Deliverability",
      text: `${Math.round((hardBouncedCount / allCount) * 100)}% of replies are hard bounces. Clean or enrich those contacts before sending more.`,
      actions: actions.showBounced ? [{ label: "Show bounced", run: actions.showBounced }] : []
    });
  }
  if (unreadCount > 0) {
    out.push({
      tone: "hot",
      key: "unread",
      // Deliberately no total. /outbox/email/replies/stats counts replies at
      // the MESSAGE level (110 unread of 205 unfiltered here) while the page's
      // Replied tile counts something narrower (17), so quoting the stats
      // figure put two contradicting numbers on one screen. The filter shows
      // the real count the moment they click through.
      label: "Unread replies waiting",
      text: "Replies waiting are meetings waiting. Read these first.",
      actions: actions.showUnread ? [{ label: "Show unread", run: actions.showUnread }] : []
    });
  }
  if (openThread) {
    if ((activeSequences || []).length) {
      const names = activeSequences.map(seq => seq.name);
      out.push({
        tone: "warn",
        key: "replied_enrolled",
        label: `Replied but still in ${names.join(", ")}`,
        text: "They answered, so further automated steps will read as spam. Pause them in the sequence.",
        actions: actions.pauseInSequence
          ? [{ label: "Pause them", run: () => actions.pauseInSequence(activeSequences[0]) }]
          : []
      });
    }
  }

  const list = Array.isArray(feed) ? feed : [];
  const ms = d => { const t = new Date(d).getTime(); return Number.isFinite(t) ? t : 0; };
  if (activeFilter === "replied") {
    if (unreadCount > 3) {
      // Promised bucketing by intent until it turned out the inbox list carries
      // contact envelopes, not message bodies -- so the copilot could not read
      // intent without opening every thread. Says what it can actually do.
      out.push({ tone: "hot", key: "triage", label: "Replies to work through", text: "Meeting requests age fastest. Filter to unread and take them oldest first." });
    }
    const staleUnread = list.filter(c => c.unread && ms(c.latestDate) && now - ms(c.latestDate) > 2 * DAY).length;
    if (staleUnread) {
      out.push({ tone: "warn", key: "stale_unread", label: `${staleUnread} repl${staleUnread === 1 ? "y" : "ies"} waiting over 2 days`, text: "Replies go cold after 48 hours. Answer these first." });
    }
  }
  const { softBouncedCount = 0 } = stats;
  if (softBouncedCount > 0 && allCount > 0 && softBouncedCount / allCount >= 0.1) {
    out.push({ tone: "warn", key: "soft_bounces", label: "Soft bounces climbing", text: "Usually an inbox over its limit or a reputation dip. Check the sending inbox and domain health." });
  }
  if (openThread) {
    out.push({ tone: "neutral", key: "open_thread", label: "This thread", text: "I can draft the reply, or read it and tell you the next step: book, answer, snooze, or ask for the right person." });
  }
  return out;
};

export default inboxFindings;
